import type { ISupportedCurrency } from "@/api/AppApi/services/company/interfaces/ICompany";
import type { ITaxSnapshot } from "@/api/AppApi/services/company/interfaces/tax";
import { createAtomWithSafeStorage } from "@/utils/atom/atomStorageUtil";

export interface IExchangeItem {
  id: number;
  quantity: number;
  note: string;
  name: string;
  price: number;
  tax?: number;
  thumbnail: string;
  sold_quantity: number;
}

export interface IExchangeState extends ITaxSnapshot {
  orderId: number;
  items: IExchangeItem[];
  currency?: ISupportedCurrency;
  shippingCharge?: number;
}

export const exchangeAtom = createAtomWithSafeStorage<IExchangeState | null>(
  "exchange_data",
  null
);
